import { pnTokenManager } from '@pn/core/services/authentication/tokenManager';
import env from '@pn/core/utils/env';
import { impersonationUserId } from '@pn/core/utils/impersonate';
import { removeNilFields } from '@pn/core/utils/logic';
import { isNil } from 'lodash-es';
import { makeRequest, type ApiRequestParams } from './apiClient';

const { PN_API_URL, PN_API_KEY } = env;

if (!isNil(impersonationUserId)) {
  console.log(
    '%c IMPERSONATION ACTIVE %c User ID:',
    'background: #b91c1c; color: #fff; font-weight: bold; padding: 2px 6px; border-radius: 3px;',
    'font-weight: bold;',
    impersonationUserId
  );
}

export const pnApiClient = {
  request: <T>(params: ApiRequestParams) =>
    makeRequest<T>({
      baseUrl: PN_API_URL,
      tokenManager: pnTokenManager,
      extraHeaders: removeNilFields({
        'X-Api-Key': PN_API_KEY,
        'X-Impersonate-User-Id': impersonationUserId,
      }),
      params,
      observeMinimumBuildNumber: true,
    }),
};
